export function joinPath(...paths) {
  return paths
    .reduce(
      (parts, path) => parts.concat((parts.length ? path.replace(/^\//, '') : path.replace(/\/$/, '')).split('/')),
      [],
    )
    .reduce((parts, part) => {
      switch (part) {
        case '.':
          break;
        case '..':
          parts.pop();
          break;
        default:
          parts.push(part);
          break;
      }
      return parts;
    }, [])
    .join('/');
}

/**
 * Function to check if the given filename has the given extension
 */
export function checkForFileExtension(fileName, extension) {
  return extension === fileName.split('.').pop();
}

/**
 * Process a directory
 */
export async function parseFolder(folder) {
  const reader = folder.createReader();
  const files = [];

  function read(resolve) {
    reader.readEntries(async (entries) => {
      if (!entries.length) {
        resolve(files);
        return;
      }

      await entries.reduce(async (acc, entry) => {
        await acc;
        if (entry.isFile) {
          files.push(entry);
        } else {
          files.push(...(await parseFolder(entry)));
        }
      }, Promise.resolve());

      read(resolve);
    });
  }

  return new Promise(read);
}
